/**
 * token 登录验证标识
 * userInfo 登陆用户信息
 * studentMajorUuid 学生当前专业
 * studentMajorName 学生当前专业名称
 */

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  let thisContent = content;
  if (!name) return;
  if (typeof thisContent !== 'string') {
    thisContent = JSON.stringify(thisContent);
  }
  window.localStorage.setItem(name, thisContent);
};

export const setLocalStore = (name, content) => {
  let thisContent = content;
  if (!name) return;
  if (typeof thisContent !== 'string') {
    thisContent = JSON.stringify(thisContent);
  }
  window.localStorage.setItem(name, thisContent);
};


/**
 * 获取localStorage
 */
export const getStore = (name) => {
  if (!name) {
    return false;
  }
  return window.localStorage.getItem(name);
};
export const getLocalStore = (name) => {
  if (!name) {
    return false;
  }
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
export const removeStore = (name) => {
  if (!name) return;
  window.localStorage.removeItem(name);
};
export const removeLocalStore = (name) => {
  if (!name) return;
  window.localStorage.removeItem(name);
};
